<script>
    import {createEventDispatcher, onMount} from 'svelte';
    import {mainTimeline, scenes} from "../../timelines/main-timeline";

    import Info1_1 from "./boxes_1/Info1_1.svelte";
    import Info1_2 from "./boxes_1/Info1_2.svelte";
    import Info1_3 from "./boxes_1/Info1_3.svelte";
    import Info1_4 from "./boxes_1/Info1_4.svelte";
    import Info2_1 from "./boxes_2/Info2_1.svelte";
    import Info2_2 from "./boxes_2/Info2_2.svelte";
    import Info3_1 from "./boxes_3/Info3_1.svelte";
    import Info4_1 from "./boxes_4/Info4_1.svelte";
    import Info4_2 from "./boxes_4/Info4_2.svelte";
    import Info4_3 from "./boxes_4/Info4_3.svelte";
    import Info4_4 from "./boxes_4/Info4_4.svelte";
    import Info4_5 from "./boxes_4/Info4_5.svelte";
    import Info4_6 from "./boxes_4/Info4_6.svelte";
    import Info4_7 from "./boxes_4/Info4_7.svelte";
    import Info4_8 from "./boxes_4/Info4_8.svelte";
    import Info4_9 from "./boxes_4/Info4_9.svelte";
    import Info5_1 from "./boxes_5/Info5_1.svelte";
    import Info5_2 from "./boxes_5/Info5_2.svelte";
    import Info5_3 from "./boxes_5/Info5_3.svelte";
    import Info6_1 from "./boxes_6/Info6_1.svelte";
    import Info6_2 from "./boxes_6/Info6_2.svelte";
    import Info6_3 from "./boxes_6/Info6_3.svelte";
    import Info7_1 from "./boxes_7/Info7_1.svelte";
    import Info7_2 from "./boxes_7/Info7_2.svelte";
    import Info7_3 from "./boxes_7/Info7_3.svelte";
    import Info8_1 from "./boxes_8/Info8_1.svelte";
    import Info8_2 from "./boxes_8/Info8_2.svelte";
    import Info8_3 from "./boxes_8/Info8_3.svelte";
    import Info8_4 from "./boxes_8/Info8_4.svelte";
    import Info9_1 from "./boxes_9/Info9_1.svelte";
    import Info11_1 from "./boxes_11/Info11_1.svelte";

    export let scene = 0;
    export let subScene = 0;

    const dispatch = createEventDispatcher();

    function handleThoughtClick() {
        dispatch('toggle_thought_leadership');
    }

    function handleThoughtBusinessClick() {
        dispatch('toggle_thought_business');
    }

    function handleReadGuideClick() {
        dispatch('toggle_read_guide');
    }

    function advanceSubScene() {
        dispatch('advance_sub_scene');
    }

    const infoBoxes = [
        [],
        [],
        [
            Info1_1,
            Info1_2,
            Info1_3,
            Info1_4,
        ],
        [
            Info2_1,
            Info2_2,
        ],
        [
            Info3_1,
        ],
        [
            Info4_1,
            Info4_2,
            Info4_3,
            Info4_4,
            Info4_5,
            Info4_6,
            Info4_7,
            Info4_8,
            Info4_9,
        ],
        [
            Info5_1,
            Info5_2,
            Info5_3,
        ],
        [
            Info6_1,
            Info6_2,
            Info6_3,
        ],
        [
            Info7_1,
            Info7_2,
            Info7_3,
        ],
        [
            Info8_1,
            Info8_2,
            Info8_3,
            Info8_4,
        ],
        [
            Info9_1,
        ],
        [],
        [
            Info11_1,
        ]
    ];

    $: lastItem = subScene === (infoBoxes[scene - 1].length) - 1;
    $: showBoxes = infoBoxes[scene - 1] && infoBoxes[scene - 1].length;
    $: showSubNav = infoBoxes[scene - 1].length > 1;
    $: component = infoBoxes[scene - 1][subScene];

    const animateInLabels = scenes.filter((s) =>
        s.name !== 'planets'
        && s.name !== 'introTwo'
        && s.name !== 'introThree'
        && s.name !== 'customerJourney'
    ).map(s =>
        s.name + 'Start+=' + (s.inDuration - 0.5)
    );

    const animateOutLabels = scenes.map(s => s.name + 'End');

    onMount(() => {
        animateInLabels.forEach(label => {
            mainTimeline.fromTo('.info-box-animate-in-out', {
                opacity: 0,
            }, {
                opacity: 1,
                duration: 0.8,
            }, label);
        });

        animateOutLabels.forEach(label => {
            mainTimeline.to('.info-box-animate-in-out', {
                opacity: 0,
                duration: 0.01,
            }, label);
        });

    });

</script>

<div class="info-box-animate-in-out">
    {#if showBoxes}
        <div class="info-box-container">
            <svelte:component this={component}/>
            <div class="button-container">
                {#if showSubNav}
                    <button on:click={advanceSubScene} disabled={lastItem}>
                        <img src="images/sub-arrow-right.svg" alt="next">
                    </button>
                    <span class="sub-scene-count">{subScene + 1} / {infoBoxes[scene - 1].length}</span>
                {/if}
                {#if scene === 5}
                    <button on:click={handleThoughtClick}>
                        <img src="images/plus.svg" alt="next" class="plus-icon">
                    </button>
                {/if}
                {#if scene === 11}
                    <button on:click={handleThoughtBusinessClick}>
                        <img src="images/plus.svg" alt="next" class="plus-icon">
                    </button>
                {/if}
                {#if scene === 13}
                    <button on:click={handleReadGuideClick}>
                        <img src="images/download-icon.svg" alt="next" class="plus-icon">
                    </button>
                {/if}
            </div>
        </div>
    {/if}
</div>

<style>
    .info-box-container {
        background-color: black;
        position: relative;
        right: -40px;
        width: 100%;
        height: auto;
        color: white;
        padding: 10px;
    }

    .button-container {
        position: absolute;
        bottom: 10px;
        left: 10px;
        display: flex;
        justify-content: left;
        align-items: center;
    }

    .plus-icon {
        width: 24px;
    }

    button {
        display: inline-block;
        border: none;
        padding: 1rem 2rem;
        margin: 0;
        text-decoration: none;
        background: none;
        color: #ffffff;
        font-family: Metric, sans-serif;
        font-size: 1rem;
        cursor: pointer;
        text-align: center;
        transition: background 250ms ease-in-out,
        transform 150ms ease;
        -webkit-appearance: none;
        -moz-appearance: none;
    }

    button:hover:not(:disabled),
    button:focus {
        background: none;
        filter: invert(40%) sepia(70%) saturate(1696%) hue-rotate(336deg) brightness(103%) contrast(101%);
    }

    button:focus {
        outline: none;
        outline-offset: -4px;
    }

    button:active:not(:disabled) {
        transform: scale(0.98);
    }

    button:disabled {
        opacity: 0.2;
        cursor: default;
    }

    .info-box-animate-in-out {
        opacity: 0;
    }
</style>